import {
  Badge,
  BlockStack,
  Icon,
  InlineStack,
  LegacyStack,
  ResourceItem,
  ResourceList,
  Text,
} from '@shopify/polaris'
import { ChevronRightIcon } from '@shopify/polaris-icons'

import { AdaptiveModal } from '../common/AdaptiveModal'
import { DialogActivator } from '../common/helpers'
import * as urls from '../common/urls'
import { WorkflowCreateItemType, workflowDescriptions, workflowLabels } from './WorkflowCreateCard'

interface BaseWorkflowCreateItemProps {
  id: WorkflowCreateItemType
}

interface WorkflowCreateItemWithUrl extends BaseWorkflowCreateItemProps {
  url: string
  onClick?(id?: string): void
}
interface WorkflowCreateItemWithClick extends BaseWorkflowCreateItemProps {
  url?: string
  onClick(id?: string): void
}

type WorkflowItemProps = WorkflowCreateItemWithUrl | WorkflowCreateItemWithClick

const renderWorkflowCreateItem = (item: WorkflowItemProps) => (
  <ResourceItem {...item}>
    <InlineStack wrap={false} align="space-between" gap="200">
      <LegacyStack.Item fill>
        <BlockStack gap="200">
          <InlineStack wrap={false} blockAlign="baseline" align="start" gap="200">
            <Text variant="headingMd" as="h2">
              {workflowLabels[item.id].title}
            </Text>
            {workflowLabels[item.id].badgeLabel && (
              <Badge tone="attention">{workflowLabels[item.id].badgeLabel}</Badge>
            )}
          </InlineStack>
          <Text as="p">{workflowDescriptions[item.id]}</Text>
        </BlockStack>
      </LegacyStack.Item>
      <Icon source={ChevronRightIcon} />
    </InlineStack>
  </ResourceItem>
)

export const WorkflowCreateModal = ({
  activator,
  wizardActivator,
}: {
  activator: DialogActivator
  wizardActivator: DialogActivator
}) => {
  const workflowCreateItems = (): WorkflowItemProps[] => {
    const taggingItem = {
      id: 'tagging',
      onClick: () => {
        activator.close()
        wizardActivator.show()
      },
    } as WorkflowItemProps

    const subscriptionItem = {
      id: 'subscription',
      url: urls.subscriptionFlowsCreateUrl(),
    } as WorkflowItemProps

    const singleItem = {
      id: 'single',
      url: urls.workflowCreateUrl(),
    } as WorkflowItemProps

    return [taggingItem, subscriptionItem, singleItem]
  }

  return (
    <AdaptiveModal
      open={activator.open}
      onClose={activator.close}
      title="Create workflow"
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: activator.close,
        },
      ]}
    >
      <ResourceList items={workflowCreateItems()} renderItem={renderWorkflowCreateItem} />
    </AdaptiveModal>
  )
}
